<template>
  <div>
    <v-card class="elevation-0">
      <v-toolbar card color="white">
        <v-text-field
          flat
          solo
          hide-details
          prepend-icon="search"
          placeholder="Tìm trên danh sách thiết bị"
          v-model="table.searchText"
        ></v-text-field>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="exportToExcel()">
            <v-icon>save_alt</v-icon>
          </v-btn>
          <span>Tải về danh sách thiết bị</span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-data-table
          item-key="id"
          :headers="table.headers"
          :search="table.searchText"
          :items="datasource"
          :rows-per-page-items="[10,20,50,100]"
          :loading="isLoading"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.imei }}</td>
            <td>{{ props.item.deviceType }}</td>
            <td>
              <v-chip
                v-if="props.item.errCode"
                small
                color="red"
                text-color="white"
              >{{props.item.errCode}}</v-chip>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    datasource: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      table: {
        searchText: '',
        headers: [
          {
            text: 'IMEI',
            value: 'imei'
          },
          {
            text: 'Loại thiết bị',
            value: 'deviceType'
          },
          {
            text: 'Lỗi (Nếu có)',
            value: 'errCode'
          }
        ]
      }
    };
  },
  methods: {
    exportToExcel () {
      if (this.datasource.length > 0) {
        let dataToExport = [];
        this.datasource.map((item, index) => {
          let data = {
            STT: ++index,
            IMEI: item.imei,
            'Loại thiết bị': item.deviceType,
            'Lỗi (Nếu có)': item.errCode
          };
          dataToExport.push(data);
          return 0;
        });

        let sheet = XLSX.utils.json_to_sheet(dataToExport);
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, sheet, 'Devices');
        XLSX.writeFile(wb, 'Devices.xlsx');
      } else {
        window.getApp.showMessage('Không có dữ liệu', 'error');
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/device/components/importlist.vue